import * as t from '../actionTypes';

// -- organization
export const testCreditsOrgInput = input => ({
  type: t.TEST_CREDITS_ORG_INPUT,
  payload: input
});

export const testCreditsOrgValidate = input => ({
  type: t.TEST_CREDITS_ORG_VALIDATE,
  payload: input
});

export const testCreditsOrgValidated = input => ({
  type: t.TEST_CREDITS_ORG_VALIDATED,
  payload: input
});

export const testCreditsOrgState = input => ({
  type: t.TEST_CREDITS_ORG_STATE,
  payload: input
});

// test credits

export const createTestCreditsByProductIdInput = input => ({
  type: t.CREATE_TEST_CREDITS_INPUT,
  payload: input
});

export const getTestCreditsByProductIdRequest = input => ({
  type: t.GET_TEST_CREDITS_PRODUCTS_REQUEST,
  payload: input
});

export const getTestCreditsByProductIdSuccess = input => ({
  type: t.GET_TEST_CREDITS_PRODUCTS_SUCCESS,
  payload: input
});

export const getTestCreditsByProductIdEmptySuccess = input => ({
  type: t.GET_TEST_CREDITS_PRODUCTS_EMPTY_SUCCESS,
  payload: input
});

export const getTestCreditsByProductFailure = errors => ({
  type: t.GET_TEST_CREDITS_PRODUCTS_FAILURE,
  payload: errors
});

export const getTestCreditsByProductId = input => ({
  type: t.GET_TEST_CREDITS_PRODUCTS,
  payload: input
});

export const testCreditsReset = () => ({
  type: t.TEST_CREDITS_RESET,
  payload: null
});

// -- create
export const createTestCreditsByProductIdRequest = input => ({
  type: t.CREATE_TEST_CREDITS_REQUEST,
  payload: input
});

export const createTestCreditsByProductIdSuccess = input => ({
  type: t.CREATE_TEST_CREDITS_SUCCESS,
  payload: input
});

export const createTestCreditsByProductIdFailure = input => ({
  type: t.CREATE_TEST_CREDITS_FAILURE,
  payload: input
});

// -- update
export const updateTestCreditsByProductIdRequest = input => ({
  type: t.UPDATE_TEST_CREDITS_REQUEST,
  payload: input
});

export const updateTestCreditsByProductIdSuccess = input => ({
  type: t.UPDATE_TEST_CREDITS_SUCCESS,
  payload: input
});

export const updateTestCreditsByProductIdFailure = errors => ({
  type: t.UPDATE_TEST_CREDITS_FAILURE,
  payload: errors
});

export const getTestCreditsRequest = data => ({
  type: t.GET_TEST_CREDITS_REQUEST,
  payload: data
});

export const getTestCreditsSuccess = input => ({
  type: t.GET_TEST_CREDITS_SUCCESS,
  payload: input
});

export const getTestCreditsEmptySuccess = payload => ({
  type: t.GET_TEST_CREDITS_EMPTY_SUCCESS,
  payload
});

export const getTestCreditsFailure = errors => ({
  type: t.GET_TEST_CREDITS_FAILURE,
  payload: errors
});

export const getTestCreditsProducts = payload => ({
  type: t.GET_TEST_CREDITS_PRODUCTS,
  payload
});
